import Request from '@request/Request';
import Model from '@models/Species';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    data = {
      ...Model.data(),
      ...data,
    };
    super(validationObserver, data);
    this.model = new Model();
  }

  async submit() {
    this.beforeSubmit();
    try {
      let response = await this.model.save(this.data());
      $showSuccess(response.message, 'species-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }
}
